import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const otpVerificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_OTP_VERIFICATION_START:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case types.POST_OTP_VERIFICATION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case types.POST_OTP_VERIFICATION_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
};

export default otpVerificationReducer;
